import { DashboardLayout } from '@/components/dashboard';

export function DashboardPage() {
  return <DashboardLayout />;
}
